// extracted by mini-css-extract-plugin
export default {"stream__videoCurtainBase":"be_bf","stream__videoCurtainOverlay":"be_bg","stream__overlay":"be_bh","stream__overlayFade":"be_bi"};